import { forwardRef } from "react";
import NumberFormat from "react-number-format";

export const convertTextUnitToNumber = (value) => {
  if (isNaN(value)) {
    return 0;
  }
  if (typeof value === "number") {
    return value;
  }
  const pattern = /\D/gi;
  return pattern.test(value) ? Number(value?.replace(pattern, "")) : 0;
 //return Number(value?.replace(pattern, ""));
};

export const convertTextCurrencyToNumber = (value) => {
  
  if (typeof value === "number") {
    return value;
  }
  if (typeof value !== "string") {
    return 0;
  }
  return Number(value.replace(/[^0-9,-]+/g, "").replace(",", ".")) || 0;
};

export const NumberFormatCurrency = forwardRef(function NumberFormatCustom(
  props,
  ref
) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={ref}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator=","
      decimalScale={2}
      isNumericString
      prefix="R$"
      fixedDecimalScale
    />
  );
});
